import { Table } from 'ant-design-vue'

// Only menu-page tables receive a viewport. Dialog and nested tables retain their own layout.
export default {
  name: 'ViewportTable',
  inheritAttrs: false,
  data: () => ({ bodyHeight: 320, tableWidth: 0, autoViewport: false }),
  mounted() {
    this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.measure) }
    this.observer = new ResizeObserver(this.schedule)
    this.observer.observe(this.$el.parentElement || this.$el)
    window.addEventListener('resize', this.schedule)
    this.schedule()
  },
  updated() { if (this.schedule) this.schedule() },
  activated() { if (this.schedule) this.schedule() },
  beforeDestroy() {
    cancelAnimationFrame(this.frame)
    window.removeEventListener('resize', this.schedule)
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    measure() {
      if (!this.$el || !this.$el.getClientRects().length) return
      const parent = this.$el.parentElement
      const automatic = !parent || !parent.closest('.ant-modal, .ant-drawer, .ant-table')
      if (automatic !== this.autoViewport) this.autoViewport = automatic
      if (!automatic) return
      const rect = this.$el.getBoundingClientRect()
      const header = this.$el.querySelector('thead')
      const headerHeight = header ? header.offsetHeight : 54
      const bottom = window.innerHeight - 20
      const height = Math.max(96, Math.floor(bottom - rect.top - headerHeight - 78))
      if (height !== this.bodyHeight) this.bodyHeight = height
      if (rect.width !== this.tableWidth) this.tableWidth = rect.width
    }
  },
  render(h) {
    const attrs = this.$attrs
    const columns = this.autoViewport ? (attrs.columns || []).map(c => ({ width: 160, ...c })) : attrs.columns
    const width = (columns || []).reduce((n, c) => n + (Number(c.width) || 160), 0)
    const scroll = this.autoViewport ? { y: this.bodyHeight, ...(width > this.tableWidth ? { x: width } : {}), ...(attrs.scroll || {}) } : attrs.scroll
    return h(Table, {
      class: { 'viewport-table': this.autoViewport },
      props: { ...attrs, columns, scroll },
      on: this.$listeners,
      scopedSlots: this.$scopedSlots
    }, this.$slots.default)
  }
}
